import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/* eslint-disable max-len, react/prop-types */
var Info = function Info(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 32 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 32 : _ref$width;
  return /*#__PURE__*/_jsxs("svg", {
    "aria-hidden": "true",
    className: className,
    height: height,
    width: width,
    viewBox: "0 0 16 16",
    role: "presentation",
    children: [/*#__PURE__*/_jsx("title", {
      children: "Information Icon"
    }), /*#__PURE__*/_jsx("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1",
      transform: "translate(-17.000000, -526.000000)",
      children: /*#__PURE__*/_jsxs("g", {
        transform: "translate(17.000000, 526.000000)",
        fill: "#292D33",
        children: [/*#__PURE__*/_jsx("rect", {
          x: "7",
          y: "7",
          width: "2",
          height: "5",
          rx: "1"
        }), /*#__PURE__*/_jsx("path", {
          d: "M8,14 C11.3137085,14 14,11.3137085 14,8 C14,4.6862915 11.3137085,2 8,2 C4.6862915,2 2,4.6862915 2,8 C2,11.3137085 4.6862915,14 8,14 Z M8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 Z",
          fillRule: "nonzero"
        }), /*#__PURE__*/_jsx("circle", {
          cx: "8",
          cy: "5",
          r: "1.25"
        })]
      })
    })]
  });
};

export default Info;